import script from "./passwordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./passwordForm.vue?vue&type=script&setup=true&lang=js"

import "./passwordForm.vue?vue&type=style&index=0&id=35d0d899&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35d0d899"]])

export default __exports__